/**
 * FAQ data for the Help & Support page accordions.
 * summary       - shown on the collapsed accordion row
 * contentHeader - header shown when the accordion is expanded
 * contentBody   - the answer
 * category      - used to group FAQs under headings (helpInfo.js)
 */

const HelpData = [
  // ---- Cases & incidents ------------------------------------------------
  {
    id: 1,
    category: "Cases & incidents",
    summary: "How do I change the status of a case?",
    contentHeader: "How do I change the status of a case?",
    contentBody:
      "Open the incident from the Incidents list, then use the Status dropdown near the top of the incident detail (e.g. New, Investigate, Waiting, Blocked, Closed). Choose the new status and confirm. The change is recorded on the Activity tab.",
  },
  {
    id: 2,
    category: "Cases & incidents",
    summary: "How do I assign or reassign a responder?",
    contentHeader: "How do I assign or reassign a responder?",
    contentBody:
      "On the incident detail, use the Assigned To control to assign or reassign a responder. If your school uses on-call scheduling, new incidents can route to the current on-call responder automatically.",
  },
  {
    id: 3,
    category: "Cases & incidents",
    summary: "What should I do if I need to escalate a case?",
    contentHeader: "What should I do if I need to escalate a case?",
    contentBody:
      "Use the Escalate action on the incident detail and confirm. Escalation notifies the next level of responders (your school's escalation on-call or the next tier up, e.g. principal/assistant principal) so a higher authority can step in. Use De-Escalate to return it to normal handling.",
  },
  {
    id: 4,
    category: "Cases & incidents",
    summary: "Can I track the history of actions taken on a case?",
    contentHeader: "Can I track the history of actions taken on a case?",
    contentBody:
      "Yes. Open the incident and select the Activity tab for a full, time-stamped timeline — status changes, assignments, escalations, messages, and de-anonymization events — so you have a defensible record of how the report was handled.",
  },
  {
    id: 5,
    category: "Cases & incidents",
    summary: "What do the priority levels (Low / Medium / High) mean?",
    contentHeader: "What do the priority levels mean?",
    contentBody:
      "Priority is set automatically from the report: an emergency-flagged report is High; certain types (e.g. physical or sexual) raise urgency; everything else defaults to Medium. Priority is a triage starting point — a responder can act on their judgment.",
  },

  // ---- Communicating with students -------------------------------------
  {
    id: 6,
    category: "Communicating with students",
    summary: "How can I message a student to clarify a situation?",
    contentHeader: "How can I message a student about their report?",
    contentBody:
      "Open the incident and use “Message the Student” to open the chat panel. Messages are two-way and the student can reply in their app. The student stays anonymous to you unless an approved de-anonymization has occurred.",
  },
  {
    id: 7,
    category: "Communicating with students",
    summary: "Can a student add information after submitting a report?",
    contentHeader: "Can a student add information after submitting?",
    contentBody:
      "Yes. Students can send updates on their own report at any time — they don't have to wait for you to message first — so new information can arrive as a situation develops.",
  },

  // ---- Privacy & anonymity ---------------------------------------------
  {
    id: 8,
    category: "Privacy & anonymity",
    summary: "How does student anonymity work?",
    contentHeader: "How does student anonymity work?",
    contentBody:
      "Students are anonymous to their peers and to staff by default. Their identity is stored securely by the system so that misuse can be traced and so a designated approver can reveal identity when safety requires it — but it is never shown casually.",
  },
  {
    id: 9,
    category: "Privacy & anonymity",
    summary: "Who can de-anonymize a student, and is it recorded?",
    contentHeader: "Who can de-anonymize a student, and is it recorded?",
    contentBody:
      "De-anonymization is a deliberate, approved action. A responder requests it with a reason; a designated approver (e.g. principal/assistant principal or an admin tier) approves it. Every request and approval is written to the audit log with who and why.",
  },

  // ---- Account & access -------------------------------------------------
  {
    id: 10,
    category: "Account & access",
    summary: "How do I change my password or update my profile?",
    contentHeader: "How do I change my password or update my profile?",
    contentBody:
      "Go to My Account. Under Account you can change your password and update your details; under Personal Information you can edit your name and contact info. Save your changes when done.",
  },
  {
    id: 11,
    category: "Account & access",
    summary: "How do I set my availability or Paid Time Off (PTO)?",
    contentHeader: "How do I set my availability or PTO?",
    contentBody:
      "In My Account, open the Personal Time Off section and add your start/end dates. When on-call and assignment are availability-aware, incidents won't route to you while you're on approved PTO.",
  },
  {
    id: 12,
    category: "Account & access",
    summary: "How do I add or manage staff and responders?",
    contentHeader: "How do I add or manage staff and responders?",
    contentBody:
      "If your role allows it, use the Users/People area to add staff, set their school association, and assign roles. Role and permission changes take effect on their next sign-in.",
  },

  // ---- Notifications ----------------------------------------------------
  {
    id: 13,
    category: "Notifications",
    summary: "How do I control which notifications I receive?",
    contentHeader: "How do I control which notifications I receive?",
    contentBody:
      "Open My Account and find Notification preferences to opt in or out of notification types. The bell icon in the header shows your in-app notifications; select an item to jump to the related report.",
  },
];

export default HelpData;
